import Vue from 'vue';

Vue.component('attendant-session-index', () =>
    import(/* webpackChunkName: 'attendant-session-index' */ './attendant-session-index.vue'),
);
